import { performPostAuthRedirect } from "../../../utils/redirectUtils";
import { validateSignInForm } from "./signInValidation";

/**
 * Create form submit handler
 */
export const createHandleSubmit = (
  formData,
  setFormErrors,
  setIsLoading,
  setSubmitError,
  login,
  searchParams,
  locationState,
  navigate,
  t,
) => {
  return async (e) => {
    e.preventDefault();

    const validation = validateSignInForm(formData, t);
    if (!validation.isValid) {
      setFormErrors(validation.errors);
      return;
    }

    setIsLoading(true);
    setSubmitError("");

    try {
      const result = await login(formData.email.trim(), formData.password);

      if (result.success) {
        performPostAuthRedirect(searchParams, locationState, navigate);
      } else {
        setSubmitError(result.error || t("errors.signInFailed"));
      }
    } catch (error) {
      console.error("Login error:", error);
      setSubmitError(t("errors.signInFailed"));
    } finally {
      setIsLoading(false);
    }
  };
};

/**
 * Create Google login success handler
 */
export const createHandleGoogleSuccess = (
  setIsLoading,
  setSubmitError,
  loginWithGoogle,
  searchParams,
  locationState,
  navigate,
  t,
) => {
  return async (credentialResponse) => {
    setIsLoading(true);
    setSubmitError("");

    try {
      const result = await loginWithGoogle(credentialResponse.credential);

      if (result.success) {
        performPostAuthRedirect(searchParams, locationState, navigate);
      } else {
        let errorMessage = result.error || t("errors.googleAuthFailed");

        // Check for specific backend errors
        if (result.error && result.error.includes("404")) {
          errorMessage =
            "Backend Google login endpoint not found. Please check if /login/google endpoint exists.";
        } else if (result.error && result.error.includes("Not Found")) {
          errorMessage =
            "Google login endpoint not implemented on backend. Please check server configuration.";
        }

        setSubmitError(errorMessage);
      }
    } catch (error) {
      console.error("Google login error:", error);
      setSubmitError(t("errors.googleAuthFailed"));
    } finally {
      setIsLoading(false);
    }
  };
};

/**
 * Handle Google login error
 */
export const handleGoogleError = (error, t) => {
  console.error("Google authentication error:", error);
  return t("errors.googleAuthFailed");
};
